import { logPageViewGA } from 'Shared/ga';
import { trackMP } from 'Shared/mp';

/**
 * The purchase analytics, which normally fire on `/welcome`. A popup never gets there — it closes
 * itself — so it fires them before it goes, and `/welcome` calls the same function.
 */
const trackPurchase = ({ passType, price }: { passType?: string | null; price?: string | null }) => {
  if (!passType || !price) {
    return;
  }
  logPageViewGA('/checkout-completed', true, false);
  trackMP('stripe-checkout-completed');
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'CheckoutCompleted');
  }
  logPageViewGA(`/purchased-${passType}`, false, false);
  trackMP(`purchased-${passType}`);

  const formattedPrice = parseInt(price, 10) / 100;
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', `Purchased${passType}`);
    window.fbq('track', 'Purchase', { value: formattedPrice, passType, currency: 'CAD' });
  }
};

export default trackPurchase;
